import { useState, useEffect, useCallback, ChangeEvent } from 'react';

const useSearchAndList = <T>(onSearchChange?: (term: string) => T[]) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [displayedList, setDisplayedList] = useState<T[]>([]);

    const handleSearchTerm = useCallback(
        ({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
            setSearchTerm(value);
        },
        [],
    );

    useEffect(() => {
        if (!searchTerm || !onSearchChange) return;
        setDisplayedList(onSearchChange(searchTerm));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchTerm]);

    return {
        searchTerm,
        displayedList,
        handleSearchTerm,
    };
};

export default useSearchAndList;
